let apiUrl = process.env.VUE_APP_API_URL

export async function httpRoom(id: number | string) {
    const {room, spots, tourGroups, tours} = await fetch(apiUrl + 'holo-rooms-3d/r/' + id + '.json')
        .then(response => response.json());
    return {room, spots, tourGroups, tours};
}

export async function httpTour(id: number) {
    const {tour, tourSpots} = await fetch(apiUrl + 'holo-rooms-3d/t/' + id + '.json')
        .then(response => response.json());
    return {tour, tourSpots};
}
